import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { artistCard } from "../../api/asyncThuncks/artistsCards";
import { selectArtists } from "../../store/slices/artists";
import Playlist from "../../components/playlist/Playlist";
import Quill from "../../components/common/quill/Quill";
import foto from "../../assets/foto.png";

const Artists = () => {
  const dispatch = useAppDispatch();
  const { artistById } = useAppSelector(selectArtists);
  const { publicUrl } = useParams();

  useEffect(() => {
    dispatch(artistCard(publicUrl));
  }, []);

  const stripHtml = (html?: string) => {
    return html ? html.replace(/<[^>]*>/g, "").trim() : "";
  };

  const seoDescription = artistById
    ? stripHtml(artistById.description).slice(0, 150)
    : "";

  return (
    <div className="px-4 py-5 w-screen bg-white max-w-[1000px]">
      <>
        {artistById && (
          <Helmet>
            <title>{`Радіо «Сільпо» | ${artistById.name}`}</title>
            <meta name="title" content={`Радіо «Сільпо» | ${artistById.name}`} />
            <meta property="og:title" content={`Радіо «Сільпо» | ${artistById.name}`} />
            <meta name="twitter:title" content={`Радіо «Сільпо» | ${artistById.name}`} />

            <meta name="description" content={seoDescription} />
            <meta property="og:description" content={seoDescription} />
            <meta name="twitter:description" content={seoDescription} />

            {artistById.imgPath && (
              <>
                <meta property="og:image" content={artistById.imgPath} />
                <meta name="twitter:image" content={artistById.imgPath} />
              </>
            )}
          </Helmet>
        )}
        <div className="w-full flex flex-col justify-center items-center py-8 px-2">
          <div className="w-full flex flex-col justify-center items-center">
            <img
              className="w-[9.5rem] h-[9.5rem] mb-3 rounded-full shadow-lg"
              src={artistById?.imgPath ? artistById?.imgPath : foto}
              alt=""
            />
            <h1 className="mb-1 text-2xl font-bold pb-14 text-black">
              {artistById?.name}
            </h1>
            <div className="w-full">
              <span className="text-xl font-bold">Опис</span>
              <p className="text-left text-base pt-2">
                <Quill
                  text={artistById?.description}
                  className={"artist h-auto"}
                />
              </p>
            </div>
            {artistById && artistById?.audioTracks.length > 0 && (
              <div className="w-full pt-10 md:pt-7 pb-10">
                <Playlist audioTracks={artistById.audioTracks} />
              </div>
            )}
          </div>
        </div>
      </>
    </div>
  );
};

export default Artists;
